module.exports = __webpack_public_path__ + "img/knu2_detail.efd75301.jpg";